// extracted by mini-css-extract-plugin
export default {"adapt-content":"AdaptScreen_adapt-content__z--1P","adapt-view":"AdaptScreen_adapt-view__Dr+J5"};